import gql from 'graphql-tag';

export const unsubscribeApacSavedSearchByCode = gql`
  mutation UnsubscribeApacSavedSearchByCode(
    $input: UnsubscribeApacSavedSearchByCodeInput!
  ) {
    unsubscribeApacSavedSearchByCode(input: $input) {
      ... on UnsubscribeApacSavedSearchByCodeFailure {
        error {
          message
        }
      }
    }
  }
`;
